module.exports = __webpack_public_path__ + "img/gratis-ongkir.82a38c83.svg";